function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import WS from "isomorphic-ws";
import { SignalType } from "./signal";
var MAX_WS_RECONN_BACKOFF_MS = 32000; // 32 seconds
var MAX_WS_RECONN_TIME_MS = 300000; // 5 minutes
var WebSocket = /*#__PURE__*/ function() {
    "use strict";
    function WebSocket(uri, accessToken) {
        var _this = this;
        _classCallCheck(this, WebSocket);
        this._handleSocketOpen = function() {
            var _this2 = _this;
            var _obj, ref;
            _this._setupHeartbeat();
            // console.log('sending ' + this._pendingMessages.length + ' pending messages');
            _this._pendingMessages.forEach(function(s) {
                _this2.send(s);
            });
            _this._pendingMessages = [];
            (ref = (_obj = _this)._onopen) === null || ref === void 0 ? void 0 : ref.call(_obj, _this._connRetries);
            _this._connRetries = 0;
            _this._disconnectStart = 0;
        };
        this._handleSocketError = function(e) {
            if (_this._onerror) _this._onerror(e);
        };
        var _this1 = this;
        this._handleSocketClose = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
                var now, jitter, backoff;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // console.log('_handleSocketClose');
                            _this1._clearHeartbeat();
                            if (!_this1._disconnectStart) {
                                _ctx.next = 11;
                                break;
                            }
                            now = new Date();
                            if (!(now.getTime() - _this1._disconnectStart >= MAX_WS_RECONN_TIME_MS)) {
                                _ctx.next = 9;
                                break;
                            }
                            console.log("final disconnect");
                            if (_this1._ondisconnect) _this1._ondisconnect();
                            _this1._disconnectStart = 0;
                            _this1._connRetries = 0;
                            return _ctx.abrupt("return");
                        case 9:
                            _ctx.next = 12;
                            break;
                        case 11:
                            {
                                _this1._disconnectStart = new Date().getTime();
                            }
                        case 12:
                            _ctx.t0 = _this1._connRetries > 2 && _this1._shouldRetry;
                            if (!_ctx.t0) {
                                _ctx.next = 17;
                                break;
                            }
                            _ctx.next = 16;
                            return _this1._shouldRetry();
                        case 16:
                            _ctx.t0 = !_ctx.sent;
                        case 17:
                            if (!_ctx.t0) {
                                _ctx.next = 20;
                                break;
                            }
                            _this1._onNoRetry && _this1._onNoRetry();
                            return _ctx.abrupt("return");
                        case 20:
                            jitter = Math.floor(Math.random() * 1000);
                            backoff = Math.min(Math.pow(2, _this1._connRetries) + jitter, MAX_WS_RECONN_BACKOFF_MS);
                            _this1._connRetries++;
                            _this1._retryTimeout = setTimeout(function() {
                                var _obj, ref;
                                console.log("retrying websocket conn");
                                (ref = (_obj = _this1)._onretry) === null || ref === void 0 ? void 0 : ref.call(_obj, _this1._connRetries);
                                _this1._reinitWebSocket(_this1._uri);
                            }, backoff);
                            return _ctx.abrupt("return");
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }();
        this._connRetries = 0;
        this._disconnectStart = 0;
        this._uri = uri;
        this._heartbeatInterval = null;
        this._retryTimeout = null;
        this._accessToken = accessToken;
        var wsProtos = [];
        if (this._accessToken) {
            wsProtos = [
                "Bearer%".concat(this._accessToken)
            ];
        }
        this.socket = new WS(uri, wsProtos);
        this._messageListeners = [];
        this._pendingMessages = [];
        this._setupEventListeners();
    }
    var _proto = WebSocket.prototype;
    _proto._setupEventListeners = function _setupEventListeners() {
        this.socket.addEventListener("open", this._handleSocketOpen);
        this.socket.addEventListener("error", this._handleSocketError);
        this.socket.addEventListener("close", this._handleSocketClose);
    };
    _proto._removeEventListeners = function _removeEventListeners() {
        var _this = this;
        this.socket.removeEventListener("open", this._handleSocketOpen);
        this.socket.removeEventListener("error", this._handleSocketError);
        this.socket.removeEventListener("close", this._handleSocketClose);
        this._messageListeners.forEach(function(onmessage) {
            _this.socket.removeEventListener("message", onmessage);
        });
    };
    _proto._reinitWebSocket = function _reinitWebSocket(uri) {
        var _this = this;
        this._removeEventListeners();
        var wsProtos = [];
        if (this._accessToken) {
            wsProtos = [
                "Bearer%".concat(this._accessToken)
            ];
        }
        this.socket = new WS(uri, wsProtos);
        this._messageListeners.forEach(function(onmessage) {
            _this.socket.addEventListener("message", onmessage);
        });
        this._uri = uri;
        this._setupEventListeners();
    };
    _proto.addMessageListener = function addMessageListener(onmessage) {
        this._messageListeners.push(onmessage);
        this.socket.addEventListener("message", onmessage);
    };
    _proto.removeMessageListener = function removeMessageListener(onmessage) {
        this.socket.removeEventListener("message", onmessage);
    };
    _proto._clearHeartbeat = function _clearHeartbeat() {
        if (this._heartbeatInterval) {
            clearInterval(this._heartbeatInterval);
        }
    };
    _proto._setupHeartbeat = function _setupHeartbeat() {
        var _this = this;
        this._heartbeatInterval = setInterval(function() {
            if (!_this.socket) {
                console.error("no socket for heartbeat");
                return;
            }
            _this.send({
                type: SignalType.Heartbeat
            });
        }, 3000);
    };
    _proto.syncSend = function syncSend(s) {
        var _this = this;
        return new Promise(function(resolve) {
            var _this3 = _this;
            var handler = function(event) {
                var response = JSON.parse(event.data);
                if (response.id === s.id) {
                    resolve(response);
                    _this3.socket.removeEventListener("message", handler);
                }
            };
            _this.socket.addEventListener("message", handler);
            if (_this.socket.readyState !== WS.OPEN) {
                // console.log(
                //     'syncsend called in socket non open readystate',
                //     s.type,
                //     this.socket.readyState
                // );
                _this._pendingMessages.push(s);
                return;
            }
            // console.log('sync sending message', s.type);
            _this.socket.send(JSON.stringify(s));
        });
    };
    _proto.send = function send(s) {
        if (this.socket.readyState !== WS.OPEN) {
            // console.log(
            //     'send called in socket non open readystate',
            //     s.type,
            //     this.socket.readyState
            // );
            this._pendingMessages.push(s);
            return;
        }
        // console.log('sending message', s.type);
        this.socket.send(JSON.stringify(s));
    };
    _proto.close = function close() {
        this._clearHeartbeat();
        if (this._retryTimeout) {
            clearTimeout(this._retryTimeout);
        }
        this._removeEventListeners();
        this.socket.close();
    };
    _createClass(WebSocket, [
        {
            key: "onopen",
            set: function set(onopen) {
                if (this.socket.readyState === WS.OPEN) {
                    onopen(0);
                }
                this._onopen = onopen;
            }
        },
        {
            key: "onerror",
            set: function set(onerror) {
                this._onerror = onerror;
            }
        },
        {
            key: "onretry",
            set: function set(onretry) {
                this._onretry = onretry;
            }
        },
        {
            key: "ondisconnect",
            set: function set(ondisconnect) {
                this._ondisconnect = ondisconnect;
            }
        },
        {
            key: "onNoRetry",
            set: function set(onNoRetry) {
                this._onNoRetry = onNoRetry;
            }
        },
        {
            key: "shouldRetry",
            set: function set(shouldRetry) {
                this._shouldRetry = shouldRetry;
            }
        }
    ]);
    return WebSocket;
}();
export { WebSocket };
